module.exports = __webpack_public_path__ + "static/HERO_SF-41d7114a25cbd6f9e512b6a74c1ccf4b.png";